import React from 'react';
import { motion } from 'framer-motion';
import { PackSelector } from './PackSelector';
interface FinalCTAProps {
  onCTAClick?: () => void;
}
export function FinalCTA({}: FinalCTAProps) {
  return <section className="w-full py-10 sm:py-20 bg-violet-rich/30" data-id="element-68">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8 sm:mb-12" data-id="element-70">
          <h2 className="font-display text-2xl sm:text-4xl font-bold text-white mb-3 sm:mb-4" data-id="element-71">
            No dejes pasar esta oportunidad
          </h2>
          <p className="text-sm sm:text-base text-violet-100/70" data-id="element-72">
            Termina en pocas horas
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-73">
          <PackSelector data-id="element-74" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center text-violet-100/60 text-[10px] sm:text-sm mt-6 sm:mt-8 flex flex-wrap justify-center gap-x-2 gap-y-1" data-id="element-75">
          <span data-id="element-76">Pago seguro</span>
          <span className="hidden sm:inline" data-id="element-77">·</span>
          <span data-id="element-78">Acceso en 5 min</span>
          <span className="hidden sm:inline" data-id="element-79">·</span>
          <span data-id="element-80">Garantía 7 días</span>
          <span className="hidden sm:inline" data-id="element-81">·</span>
          <span data-id="element-82">Mercado Pago</span>
        </motion.p>
      </div>
    </section>;
}